<h2 mat-dialog-title data-testid="pdm-title">
  {{ (data.title || 'AmendYourDetailsTitle') | translate }}
</h2>

<mat-dialog-content>
  <p class="description">
    {{ (data.description || 'AmendYourDetailsDescription') | translate }}
  </p>

  <app-personal-details-form
    [config]="data.config"
    (valueChange)="onValueChange($event)"
    (validityChange)="onValidityChange($event)"
  ></app-personal-details-form>

  <div *ngIf="error" class="error-message" data-testid="pdm-error">
    <mat-icon>error</mat-icon>
    {{ error | translate }}
  </div>
</mat-dialog-content>

<mat-dialog-actions class="actions space-between">
  <button
    class="def-button outline"
    (click)="cancel()"
    [disabled]="saving"
    data-testid="pdm-cancel"
  >
    {{ 'Cancel' | translate }}
  </button>
  <button
    class="def-button black"
    (click)="save()"
    [disabled]="!canSave"
    data-testid="pdm-save"
  >
    <mat-spinner
      *ngIf="saving"
      diameter="20"
      style="display: inline-block; margin-right: 8px;"
    ></mat-spinner>
    {{ saving ? ('Saving' | translate) : ('Save' | translate) }}
  </button>
</mat-dialog-actions>
